export const isTest = () => process.env.NODE_ENV === 'test';

export const isDev = () => process.env.NODE_ENV === 'development';

export const isProd = () => {
  const { hostname } = window?.location || {};
  return hostname === 'www.strava.com' || hostname === 'admin.strava.com';
};

export const timeout = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const devLog = (message: string | object, warn = false) => {
  if (isDev()) {
    if (warn) {
      // eslint-disable-next-line no-console
      console.warn(message);
    } else {
      // eslint-disable-next-line no-console
      console.log(message);
    }
  }
};
